import { createContext } from 'react';

import { Context } from '../../../types';
import { ServiceStartDateOption } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

const ServiceStartDateOptionsContext = createContext<Context<ServiceStartDateOption>>(
    getContextDefaultValues(api)
);
export default ServiceStartDateOptionsContext;
